(function() { module.exports = window["wp"]["autop"]; }());